import { useMemo } from 'react'
import { useForm } from 'react-hook-form'
import { localeEnumOptions, OptionEnum } from '~/shared/config/constants'
import { LocaleEnum } from '~/shared/config/enums'
import { DEFAULT_LOCALE, i18nModel } from '~/shared/lib/i18n'
import { AutocompleteInput, FormProvider } from '~/shared/ui/Form'
import { useLocaleKeyStorage } from './useLocaleKeyStorage'

export function LocaleForm() {
  const { localeStorageKeyGet, localeStorageKeySet } = useLocaleKeyStorage()

  const defaultValues = useMemo(() => {
    const locale = localeStorageKeyGet() || DEFAULT_LOCALE
    return {
      locale: localeEnumOptions.find(
        (localeOption) => localeOption.id === locale,
      ),
    }
  }, [localeStorageKeyGet])

  const form = useForm({
    defaultValues,
  })

  const handleLocaleChange = (locale: OptionEnum<LocaleEnum>) => {
    const localeKey = locale.id
    form.setValue('locale', locale)
    i18nModel.localeChangeFx({ locale: localeKey })
    localeStorageKeySet(localeKey)
  }

  const selectedLocaleId = form.watch('locale')?.id

  return (
    <FormProvider form={form}>
      <AutocompleteInput
        startDecorator={
          <img
            src={`/icons/${selectedLocaleId}.png`}
            width='22px'
            alt='icon flag'
          />
        }
        name='locale'
        options={localeEnumOptions}
        disableClearable
        size='sm'
        onChange={(_, value) =>
          handleLocaleChange(value as OptionEnum<LocaleEnum>)
        }
      />
    </FormProvider>
  )
}
